/**
 * Audio configuration for ASTRA
 * Defines all sound paths and categories
 */

// Base path for all audio assets
const AUDIO_BASE = 'assets/audio';

/**
 * Music tracks - looping background music with dynamic transitions
 */
export const MUSIC_TRACKS: Record<string, string> = {
  // Space music
  space_calm: `${AUDIO_BASE}/music/calm.mp3`,
  space_danger: `${AUDIO_BASE}/music/space_danger.mp3`,
  space_combat: `${AUDIO_BASE}/music/space_combat.mp3`,

  // Location music
  planet: `${AUDIO_BASE}/music/planet.mp3`,
  station: `${AUDIO_BASE}/music/station.mp3`,
};

/**
 * Game SFX - Combat, mining, and gameplay sounds
 */
export const SFX_GAME: Record<string, { path: string; loop?: boolean; volume?: number }> = {
  // Weapons (reduced volume)
  boost: { path: `${AUDIO_BASE}/sfx/boost.mp3`, loop: true, volume: 0.6 },
  brake: { path: `${AUDIO_BASE}/sfx/brake.mp3`, loop: true, volume: 0.15 },
  scanner: { path: `${AUDIO_BASE}/sfx/scanner.mp3`, loop: true, volume: 0.5 },
  weapon_kinetic: { path: `${AUDIO_BASE}/sfx/weapon_kinetic.mp3`, volume: 0.3 },
  weapon_laser: { path: `${AUDIO_BASE}/sfx/weapon_laser.mp3`, loop: true, volume: 0.3 },
  weapon_missile: { path: `${AUDIO_BASE}/sfx/weapon_missile.wav`, volume: 0.3 },

  // Hits
  hit_shield: { path: `${AUDIO_BASE}/sfx/hit_shield.mp3` },
  hit_hull: { path: `${AUDIO_BASE}/sfx/hit_hull.mp3` },

  // Explosions
  explosion_ship: { path: `${AUDIO_BASE}/sfx/explosion_ship.mp3` },
  explosion_asteroid: { path: `${AUDIO_BASE}/sfx/explosion_asteroid.mp3`, volume: 0.4 },

  // Overload
  overload: { path: `${AUDIO_BASE}/sfx/overload.wav`, volume: 0.5 },

  // Mining
  mining_loop: { path: `${AUDIO_BASE}/sfx/mining_loop.mp3`, loop: true },
  mining_complete: { path: `${AUDIO_BASE}/sfx/mining_complete.mp3` },
};

/**
 * UI SFX - Non-positional sounds for interface feedback
 */
export const SFX_UI: Record<string, string> = {
  // Interface
  ui_click: `${AUDIO_BASE}/ui/ui_click.mp3`,
  ui_hover: `${AUDIO_BASE}/ui/ui_hover.mp3`,
  ui_open: `${AUDIO_BASE}/ui/ui_open.mp3`,
  ui_close: `${AUDIO_BASE}/ui/ui_close.mp3`,
  ui_error: `${AUDIO_BASE}/ui/ui_error.mp3`,
  ui_success: `${AUDIO_BASE}/ui/ui_success.mp3`,

  // Station
  dock_complete: `${AUDIO_BASE}/ui/dock_complete.mp3`,
  undock: `${AUDIO_BASE}/ui/undock.mp3`,

  // Alerts
  alert_warning: `${AUDIO_BASE}/ui/alert_warning.mp3`,
  alert_danger: `${AUDIO_BASE}/ui/alert_danger.mp3`,
};

/**
 * Audio constants
 */
export const AUDIO_CONSTANTS = {
  // Default volumes (0-1)
  DEFAULT_MASTER_VOLUME: 0.5,
  DEFAULT_MUSIC_VOLUME: 0.7,
  DEFAULT_SFX_VOLUME: 0.8,

  // Crossfade
  CROSSFADE_DURATION: 2000, // 2 seconds

  // SFX pooling
  MAX_SIMULTANEOUS_SFX: 5,

  // localStorage keys
  STORAGE_KEY_MASTER: 'astra_master_volume',
  STORAGE_KEY_MUSIC: 'astra_music_volume',
  STORAGE_KEY_SFX: 'astra_sfx_volume',
};
